import api from '../../api/api'

// initial state
const state = {
	customer: {},
  errors: {},
  //success: false
  status: {
    createCustomer: null,
    updateCustomer: null,
    getCustomer: null
  }
}

// getters
const getters = {}

// actions
const actions = {
  createCustomer ({ commit, state }, params) {
    //commit('setSuccess', false)
    commit('setStatus', { createCustomer: api.status.PENDING })
    commit('setErrors', {})
    return api.createCustomer(params).then((response) => {
      commit('setCustomer', response.data.customer)
      commit('session/setUser', response.data.user, { root: true })
      //commit('setSuccess', true)
      commit('setStatus', { createCustomer: api.status.SUCCESS })
    }).catch((error) => {
      commit('setErrors', error.response.data.errors)
      commit('setStatus', { createCustomer: api.status.FAILURE })
    })
  },
  updateCustomer ({ commit, state }, params) {
    //commit('setSuccess', false)
    commit('setErrors', {})
    commit('setStatus', { updateCustomer: api.status.PENDING })
    return api.updateCustomer(params).then((response) => {
      commit('setCustomer', response.data.customer)
      commit('session/setUser', response.data.user, { root: true })
      //commit('setSuccess', true)
      commit('setStatus', { updateCustomer: api.status.SUCCESS })
    }, params).catch((error) => {
      commit('setErrors', error.response.data.errors || {})
      commit('setStatus', { updateCustomer: api.status.FAILURE })
    })
  },
  getCustomer ({ commit, state }) {
    commit('setStatus', { getCustomer: api.status.PENDING })
    return api.getCustomer().then((response) => {
      commit('setCustomer', response.data)
      commit('setStatus', { getCustomer: api.status.SUCCESS })
    }).catch((error) => {
      commit('setStatus', { getCustomer: api.status.FAILURE })
    })
  }
}

// mutations
const mutations = {
  setCustomer (state, customer) {
    state.customer = customer
  },
  setErrors (state, errors) {
    state.errors = errors
  },
  /*setSuccess (state, success) {
    state.success = success
  }*/
  setStatus (state, status) {
    Object.assign(state.status, status)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
